import React, { useState, useEffect } from "react";
import { getEventObject } from "../../../../utils/EventUtils";
import DateTime from "./DateTime";

// Presets de frequência (CRON de 5 campos) pro leigo não precisar escrever CRON. O campo cru continua editável.
const CRON_PRESETS = [
    { label: '5 min', cron: '*/5 * * * *' },
    { label: '15 min', cron: '*/15 * * * *' },
    { label: '30 min', cron: '*/30 * * * *' },
    { label: '1 hora', cron: '0 * * * *' },
    { label: '6 horas', cron: '0 */6 * * *' },
    { label: '1×/dia (9h)', cron: '0 9 * * *' },
];

/**
 * props:
 * - schedule
 * - onChange
 */
function ScheduleArea(props) {

    const [schedule, setSchedule] = useState('');
    const [isCron, setIsCron] = useState(verifyCron(props.schedule));

    useEffect(() => {
        setSchedule(props.schedule);

        if (!props.schedule) return;
        if (verifyCron(props.schedule))
            setIsCron(true);
        else if (verifyDate(props.schedule))
            setIsCron(false);
    }, [props.schedule]);

    function verifyCron(schedule) {
        return /^(@(annually|yearly|monthly|weekly|daily|hourly|reboot))|(@every (\d+(ns|us|µs|ms|s|m|h))+)|((((\d+,)+\d+|(\d+(\/|-)\d+)|\d+|\*(?:\/\d+)?) ?){5,7})$/.test(schedule);
    }

    function verifyDate(schedule) {
        // yyyy-mm-ddThh:mm:ss.mmmZ
        return /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z)$/.test(schedule);
    }

    function onInputChange(event) {
        setSchedule(event.target.value);
        props.onChange(getEventObject('schedule', event.target.value));
    }

    function applyPreset(cron) {
        setSchedule(cron);
        props.onChange(getEventObject('schedule', cron));
    }

    function onScheduleClick(event) {
        setSchedule('');
        setIsCron(!isCron);
    }

    return (
        <div className="row">
            <div className="col-12 mb-3">
                <div className="form-group">
                    {
                        isCron
                            ? (
                                <React.Fragment>
                                    <label htmlFor="schedule">Com que frequência rodar:</label>
                                    <div className='d-flex flex-wrap gap-1 mb-2'>
                                        {CRON_PRESETS.map(p => (
                                            <button key={p.cron} type='button'
                                                className={`btn btn-sm ${schedule === p.cron ? 'btn-primary' : 'btn-outline-secondary'}`}
                                                onClick={() => applyPreset(p.cron)}>{p.label}</button>
                                        ))}
                                    </div>
                                    <small className='text-muted d-block mb-1'>Escolha uma frequência — ou edite o CRON abaixo (avançado).</small>
                                    <div className="input-group input-group-merge">
                                        <button type='button' className="btn btn-secondary" onClick={onScheduleClick} title='Trocar para agendar por data e hora'>
                                            <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" /></svg>
                                        </button>
                                        <input type='text' id='schedule' className="form-control" placeholder="* * * * * *" value={schedule || ''} onChange={onInputChange} />
                                    </div>
                                </React.Fragment>
                            )
                            : (
                                <React.Fragment>
                                    <label htmlFor="date">Agendar por Data e Hora:</label>
                                    <DateTime date={Date.parse(schedule) ? schedule : ''} onChange={onInputChange} onClick={onScheduleClick} />
                                </React.Fragment>
                            )
                    }
                </div>
            </div>
        </div>
    )
}

export default ScheduleArea;